<template>
  <tr v-if="inventories">
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">Booked</th>
    <td class="sheet-cell text-center" v-for="(inventory, index) in inventories" :key="index">
      <input v-model.lazy="inventory.booked" class="sheet-input" style="background-color: transparent; outline-color: transparent" readonly/>
    </td>
  </tr>
</template>


<script>
  export default {
    props: {
      inventories: null
    }
  }
</script>


<style scoped>
  @import "../sheet.css";
</style>